import React, { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { classNames } from '../tools/helpers';
import { getBenefit, getSite } from '../tools/fetcher';

export default function Benefit({ className }) {
    const [benefits, setBenefits] = useState([]);
    const { data } = useQuery({
        queryKey: ['sites'],
        queryFn: getSite,
    });

    useEffect(() => {
        getBenefit().then((result) => {
            if (!result?.code) {
                const dt = result.map((d) => ({
                    title: d?.title?.rendered,
                    description: d?.benefit_details?.description,
                    imageSrc: d?.benefit_details?.image_src,
                    imageAlt: d?.benefit_details?.image_alt,
                }));
                setBenefits(dt);
            }
        });
    }, []);

    return (
        <div className={classNames('space-y-8 sm:space-y-[60px]', className)}>
            <div className={'flex flex-col gap-4 items-center'}>
                <p
                    className={
                        'font-bold leading-[36px] max-w-[760px] text-center text-[32px] text-primary-black-100 sm:leading-[52px] sm:text-[40px]'
                    }
                >
                    {data?.benefit?.title}
                </p>
            </div>
            <div
                className={
                    'flex flex-wrap gap-x-10 gap-y-[60px] justify-center w-full'
                }
            >
                {benefits.map((benefit, index) => (
                    <div key={index} className={'w-full sm:w-[360px]'}>
                        <div className={'flex gap-6 justify-center'}>
                            <img
                                src={benefit.imageSrc}
                                alt={benefit.imageAlt}
                                className={'h-[160px] w-[160px]'}
                            />
                        </div>
                        <p
                            className={
                                'font-bold leading-8 mt-6 text-xl text-primary-black-100 text-center'
                            }
                        >
                            {benefit.title.replace(/&#038;/g , "&")}
                        </p>
                        <p
                            className={
                                'leading-7 mt-2 text-primary-gray-101 text-center'
                            }
                        >
                            {benefit.description}
                        </p>
                    </div>
                ))}
            </div>
        </div>
    );
}
